import React, { useEffect, useState } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { get_BankDetailsData, get_BankDetailsSingleData } from "../../../store/actions/CommanAction";
import DataTable from 'react-data-table-component';
import { Dropdown, Nav, Row, Tab } from "react-bootstrap";

const BankDetails = ({ selectedAstroId }) => {
    const dispatch = useDispatch();
    const BankDetailsData = useSelector((state) => state.feedBackReducer.BankDetailsData);
    const BankDetailsSingleData = useSelector((state) => state.feedBackReducer.BankDetailsSingleData);
    const customerID = Number(sessionStorage.getItem('ID'));
    const [EditValueBank, SetEditValueBank] = useState('');
    const [clickedRow, setClickedRow] = useState(null);
    const [BankDetailsID, SetBankDetailsID] = useState();
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState(false);
    const [IsActive, setIsActive] = useState(true);

    const [Bankvalue, setBankvalue] = useState({
        'AstroID': selectedAstroId, 'AccountName': '', 'AccountNo': '', 'BankName': '', 'IFSCCode': '', 'Status': '', 'Attachmenturl': '', 'CreatedByUser': 1
    });

    useEffect(() => {
        if (IsActive) {
            dispatch(get_BankDetailsData(selectedAstroId, '1'));
        } else {
            dispatch(get_BankDetailsData(selectedAstroId, '0'));
        }
    }, [IsActive, selectedAstroId]);


    useEffect(() => {
        SetEditValueBank(BankDetailsSingleData);
    }, [BankDetailsSingleData]);


    const ResetBankDetails = () => {
        setBankvalue({
            ...Bankvalue, 'AccountName': '', 'AccountNo': '', 'BankName': '', 'IFSCCode': '', 'Status': '', 'Attachmenturl': '',
        });
        setClickedRow('');
        setStatus(false);
        setFile(null);
    }

    useEffect(() => {
        if (status && EditValueBank && EditValueBank.length > 0) {
            setBankvalue({
                ...Bankvalue,
                BankDetailsID: BankDetailsID,
                'AccountName': EditValueBank[0]?.AccountName,
                'BankName': EditValueBank[0]?.BankName,
                'IFSCCode': EditValueBank[0]?.IFSCCode,
                'AccountNo': EditValueBank[0]?.AccountNo,
                'Attachmenturl': EditValueBank[0]?.Attachmenturl,
                'ModifiedByUser': '1'
            });
        }
    }, [EditValueBank]);

  


    const SubmitBankInfo = async (e) => {
        let error = false;
        let errorMsg = '';

        // Validation checks
        if (Bankvalue.AccountName === "") {
            error = true;
            errorMsg = 'Please fill AccountName.';
        } else if (Bankvalue.AccountNo === "") {
            error = true;
            errorMsg = 'Please fill AccountNo.';
        } else if (Bankvalue.AccountNo.length < 8) {
            error = true;
            errorMsg = 'AccountNo must be at least 8 characters long.';
        } else if (Bankvalue.AccountNo.length > 17) {
            error = true;
            errorMsg = 'AccountNo must be no more than 17 characters long.';
        } else if (Bankvalue.BankName === "") {
            error = true;
            errorMsg = 'Please fill BankName.';
        }

        if (!error) {
            const formData = new FormData();
            const dataObject = {
                AstroID: Bankvalue.AstroID,
                BankDetailsID: BankDetailsID,
                AccountName: Bankvalue.AccountName,
                AccountNo: Bankvalue.AccountNo,
                BankName: Bankvalue.BankName,
                IFSCCode: Bankvalue.IFSCCode,
                Attachmenturl: Bankvalue.Attachmenturl,
                CreatedByUser: 1,
                Status: Bankvalue.Status
            };
            formData.append('Data', JSON.stringify(dataObject));
            formData.append('File', file);
            await AddUpdate('BankDetails/Insert_BankDetails', formData);
            ResetBankDetails();
            swal('Good job!', 'Successfully Added', "success");
            dispatch(get_BankDetailsData(selectedAstroId, IsActive ? '1' : '0'));
            setFile(null);
        } else {
            swal('Oops', errorMsg, "error");
        }
    }

    const handleBankInfoUpdate = async (e) => {
        let error = false;
        let errorMsg = '';
        // Validation checks
        if (Bankvalue.AccountName === "") {
            error = true;
            errorMsg = 'Please fill AccountName.';
        } else if (Bankvalue.AccountNo === "") {
            error = true;
            errorMsg = 'Please fill AccountNo.';
        } else if (Bankvalue.AccountNo.length < 8) {
            error = true;
            errorMsg = 'AccountNo must be at least 8 characters long.';
        } else if (Bankvalue.AccountNo.length > 17) {
            error = true;
            errorMsg = 'AccountNo must be no more than 17 characters long.';
        } else if (Bankvalue.BankName === "") {
            error = true;
            errorMsg = 'Please fill BankName.';
        }
        if (!error) {
            const formData = new FormData();
            const dataObject = {
                AstroID: Bankvalue.AstroID,
                BankDetailsID: BankDetailsID,
                AccountName: Bankvalue.AccountName,
                AccountNo: Bankvalue.AccountNo,
                BankName: Bankvalue.BankName,
                IFSCCode: Bankvalue.IFSCCode,
                Attachmenturl: Bankvalue.Attachmenturl,
                CreatedByUser: 1,
                Status: Bankvalue.Status
            };
            formData.append('Data', JSON.stringify(dataObject));
            formData.append('File', file);
            await AddUpdate('BankDetails/Update_BankDetails', formData);
            ResetBankDetails();
            swal('Good job!', 'Successfully Updated', "success");
            dispatch(get_BankDetailsData(selectedAstroId, IsActive ? '1' : '0'));
            setFile(null);
        }
        else {
            swal('Oops', errorMsg, "error");
        }
    }

    const fileHandler = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFile(file);
            setBankvalue(prevState => ({
                ...prevState,
                Attachmenturl: file.name
            }));
        }
    };

    const handleToggleStatusClick = async (bankDetailsID, currentStatus, isActiveValue) => {

        const postData = { BankDetailsID: bankDetailsID, DeleteByUser: customerID, IsActive: !currentStatus ? '1' : '0', };
        // const postData = { BankDetailsID: bankDetailsID, DeleteByUser: customerID, IsActive: isActiveValue, };
       
        await AddUpdate('BankDetails/Delete_BankDetails', postData);
        dispatch(get_BankDetailsData(selectedAstroId, currentStatus ? '1' : '0'));
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");

    };

    const set_Edit_Value = (row) => {
        SetBankDetailsID(row.BankDetailsID);
        setStatus(true);
        dispatch(get_BankDetailsSingleData(row.BankDetailsID));
    }

    const conditionalRowStyles = [
        {
            when: row => row === clickedRow,
            style: {
                backgroundColor: '#001f3fbd',
                color: 'white',
                cursor: 'pointer',
            },
        },
    ];

    const columns = [
        { name: 'BankName', selector: (row) => row.BankName, sortable: true },
        { name: 'AccountNo', selector: (row) => row.AccountNo, sortable: true },
        { name: 'AccountName', selector: (row) => row.AccountName, sortable: true },
        { name: 'IFSCCode', selector: (row) => row.IFSCCode, sortable: true },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.BankDetailsID, true, '0');
                                }}>
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];


    const columns1 = [
        { name: 'BankName', selector: (row) => row.BankName, sortable: true },
        { name: 'AccountNo', selector: (row) => row.AccountNo, sortable: true },
        { name: 'AccountName', selector: (row) => row.AccountName, sortable: true },
        { name: 'IFSCCode', selector: (row) => row.IFSCCode, sortable: true },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.BankDetailsID, false, '1');
                                }}>
                                Activate
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];

    
    const handleChangeBank = (e) => {
        const { name, value } = e.target;
       
        if (name === "AccountNo") {
            if (!/^\d*\.?\d*$/.test(value)) {
                return;
            }
        }
        const Bankvalue1 = { ...Bankvalue, [name]: value };
        setBankvalue(Bankvalue1);
        
    }

    return (
        <Tab.Container defaultActiveKey="All">
            <Tab.Content>
                <Tab.Pane eventKey="All">
                    <div className="pt-3">
                        <div className="pt-3">
                            <div className="settings-form">
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <div className="row">
                                        <div className="form-group mb-3 col-md-6">
                                            <label className="form-label" >Account Name</label>
                                            <span className="text-danger star-error" >*</span>
                                            <input type="text" name="AccountName" placeholder="Bank Account Name" className="form-control"
                                                value={Bankvalue?.AccountName} onChange={handleChangeBank}
                                            />
                                        </div>
                                        <div className="form-group mb-3 col-md-6">
                                            <label className="form-label">Account No</label>
                                            <span className="text-danger star-error" >*</span>
                                            <input type="text" name="AccountNo" placeholder="Bank Account No" className="form-control"
                                                value={Bankvalue?.AccountNo} onChange={handleChangeBank} autoComplete="off"
                                                minLength={8}
                                                maxLength={17}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label">Bank Name</label>
                                        <span className="text-danger star-error" >*</span>
                                        <input type="text" name="BankName" placeholder="Bank Name" className="form-control"
                                            value={Bankvalue?.BankName} onChange={handleChangeBank}
                                        />
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label">IFSC Code</label>
                                        <input type="text" name="IFSCCode" placeholder="IFSC Code" className="form-control"
                                            value={Bankvalue?.IFSCCode} onChange={handleChangeBank}
                                        />
                                    </div>
                                    <div className="post-input">
                                        <input type="file" onChange={fileHandler} id="fileInput" />
                                        <textarea name="Attachmenturl" cols={30} rows={5} className="form-control bg-transparent" placeholder="Please Attach Your Documents...." value={Bankvalue.Attachmenturl} readOnly
                                        />
                                    </div>
                                    {
                                        status ?
                                            <button className="btn btn-primary mx-1" type="submit" onClick={handleBankInfoUpdate}>Update</button>
                                            :
                                            <button className="btn btn-primary mx-1" type="submit" onClick={SubmitBankInfo}>Save</button>
                                    }
                                    <button className="btn btn-primary" type="submit" onClick={ResetBankDetails}>New</button>
                                </form>
                            </div>
                            <hr></hr>
                            <Nav variant="tabs">
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link
                                        className={`nav-link ${IsActive ? 'active' : ''}`}
                                        onClick={() => {
                                            setIsActive(true);

                                        }}
                                    >
                                        Active
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link
                                        className={`nav-link ${!IsActive ? 'active' : ''}`}
                                        onClick={() => {
                                            setIsActive(false);
                                        }}
                                    >
                                        Inactive
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            {
                                IsActive ?
                                    <>
                                        <DataTable
                                            dense
                                            data={BankDetailsData}
                                            columns={columns}
                                            selectableRowsHighlight
                                            highlightOnHover
                                            pagination
                                            onRowClicked={(row) => { setClickedRow(row); set_Edit_Value(row); }}
                                            conditionalRowStyles={conditionalRowStyles}
                                            fixedHeader
                                            persistTableHead={true}
                                            noDataComponent={"There are no data to display"}
                                        />
                                    </>
                                    :
                                    <>
                                        <DataTable
                                            dense
                                            data={BankDetailsData}
                                            columns={columns1}
                                            selectableRowsHighlight
                                            // highlightOnHover
                                            pagination
                                            conditionalRowStyles={conditionalRowStyles}
                                            fixedHeader
                                            persistTableHead={true}
                                            noDataComponent={"There are no data to display"}
                                        />
                                    </>
                            }
                        </div>
                    </div>
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>
    );
};

export default BankDetails;
